export interface ApiCustomerBank {
  CODE?: string | number;
  LABEL?: string;
  code?: string | number;
  label?: string;
  LIST_AGENCE?: string;
  [key: string]: unknown;
}

export interface BankDetailsValue {
  enabled: boolean;
  bankId: string;
  bankLabel: string;
  accountNumber: string;
}

export function emptyBankDetails(): BankDetailsValue {
  return {
    enabled: false,
    bankId: '',
    bankLabel: '',
    accountNumber: '',
  };
}

export function isBankDetailsValue(raw: unknown): raw is BankDetailsValue {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) {
    return false;
  }
  const record = raw as Record<string, unknown>;
  return (
    'enabled' in record ||
    'bankId' in record ||
    'accountNumber' in record ||
    'bank_code' in record ||
    'bank_account_number' in record
  );
}

export function parseBankDetails(raw: unknown): BankDetailsValue {
  if (raw == null || raw === '' || raw === false || raw === 'false') {
    return emptyBankDetails();
  }
  if (raw === true || raw === 'true') {
    return { ...emptyBankDetails(), enabled: true };
  }
  if (typeof raw !== 'object') {
    return emptyBankDetails();
  }

  const record = raw as Record<string, unknown>;
  const bankId = String(record['bankId'] ?? record['bank_code'] ?? record['CODE'] ?? '').trim();
  const bankLabel = String(record['bankLabel'] ?? record['bank_name'] ?? record['LABEL'] ?? '').trim();
  const accountNumber = String(
    record['accountNumber'] ?? record['bank_account_number'] ?? record['account'] ?? '',
  ).trim();
  const enabled =
    record['enabled'] === true || Boolean(bankId || bankLabel || accountNumber);

  return { enabled, bankId, bankLabel, accountNumber };
}

export function formatBankDetails(value: unknown): string {
  const parsed = parseBankDetails(value);
  if (!parsed.enabled) {
    return 'Non';
  }
  const parts = [parsed.bankLabel, parsed.accountNumber].filter(Boolean);
  return parts.length ? parts.join(' · ') : 'Oui';
}

export function customerBankCode(bank: ApiCustomerBank): string {
  return String(bank.CODE ?? bank.code ?? '').trim();
}

export function customerBankLabel(bank: ApiCustomerBank): string {
  return String(bank.LABEL ?? bank.label ?? customerBankCode(bank)).trim();
}

export function mapCustomerBanks(raw: unknown): ApiCustomerBank[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((item) => {
      const record = item && typeof item === 'object' ? (item as Record<string, unknown>) : {};
      return {
        CODE: record['CODE'] ?? record['code'],
        LABEL: record['LABEL'] ?? record['label'],
        LIST_AGENCE: record['LIST_AGENCE'] ?? record['listAgence'],
      } as ApiCustomerBank;
    })
    .filter((bank) => customerBankCode(bank) || customerBankLabel(bank));
}
